module.exports = __webpack_public_path__ + "static/animation-walk-bg-c3068ccb6491847fa3481797021c57cb.png";